module.exports = __webpack_public_path__ + "img/logo.d0b7b0be.png";